var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEnumerations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-enumerations",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M25.574,11.476H11.827v1.75H25.574Zm0,3.791H11.827v1.75H25.574ZM11.827,20.809H25.574v-1.75H11.827Z",
    transform: "translate(-5.002 -2.377)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic-2",
    "data-name": "icongraphic",
    d: "M30.16,8.917V27.583A2.92,2.92,0,0,1,27.244,30.5H8.577A2.92,2.92,0,0,1,5.66,27.583V10.525H7.994V27.583a.584.584,0,0,0,.583.583H27.244a.584.584,0,0,0,.583-.583V8.917a.584.584,0,0,0-.583-.583H5.6A2.331,2.331,0,0,1,7.937,6H27.244A2.92,2.92,0,0,1,30.16,8.917Z",
    transform: "translate(-3.971 -4.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEnumerations);
export default __webpack_public_path__ + "static/media/ico-enumerations.9e7179a861f7ac09ad32b92a8fa9d4c4.svg";
export { ForwardRef as ReactComponent };